(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-heading-dropdown"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.collection-heading-dropdown').forEach((details) => {
      const panel = details.querySelector('.details-content');
      const grid =
        details.closest('results-list')?.querySelector('[data-testid="product-grid"]') ||
        document.querySelector('results-list [data-testid="product-grid"]');
      if (!panel || !grid) return;

      function clearPanelPositionOverrides() {
        panel.style.top = '';
        panel.style.left = '';
        panel.style.right = '';
        panel.style.width = '';
        panel.style.marginLeft = '';
        panel.style.marginRight = '';
      }

      function setPanelTop() {
        const gridRect = grid.getBoundingClientRect();
        panel.style.left = '0';
        panel.style.right = '0';
        panel.style.width = '100vw';
        panel.style.marginLeft = '0';
        panel.style.marginRight = '0';
        panel.style.top = gridRect.top + 'px';
      }

      details.addEventListener('toggle', function () {
        if (details.open) {
          requestAnimationFrame(setPanelTop);
        } else {
          clearPanelPositionOverrides();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
